module.exports = __webpack_public_path__ + "img/blue-add.3f38a4b5.svg";